<my-portal-inner-load *ngIf="isLoading"></my-portal-inner-load>
<div class="mt-5 mb-5" *ngIf="!isLoading">
    <div *ngFor="let privacyItem of hotels">
        <div class="title">{{ privacyItem.hotel }}</div>
        <div [innerHTML]="privacyItem.policies.privacity?.content"></div>
    </div>
</div>